import { render, staticRenderFns } from "./Transportlist.vue?vue&type=template&id=519403ae&scoped=true&"
import script from "./Transportlist.vue?vue&type=script&lang=js&"
export * from "./Transportlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519403ae",
  null
  
)

export default component.exports